<template>
  <DialogHeader>
    <template #right>
      <div
        class="font-medium text-green-900 cursor-pointer"
        @click="handleSubmit"
      >
        Save
      </div>
    </template>
    Change your company name
  </DialogHeader>
  <DialogContent>
    <div class="mb-5">
      <UiInput v-model="companyName" label="Company name" />
    </div>
    <div class="flex items-start">
      <Toggle v-model="useCompanyName" class="mr-3" />
      <div class="font-secondary">
        If this is a company account, you can use your company name instead of
        your personal name for display throughout Dacr
      </div>
    </div>
  </DialogContent>
  <DialogFooter>
    <UiButton
      class="w-1/2 tablet-h:w-auto mr-2.5 tablet-h:mr-2"
      @click="close()"
    >
      Cancel
    </UiButton>
    <UiButton class="w-1/2 tablet-h:w-auto" primary @click="handleSubmit">
      Change company name
    </UiButton>
  </DialogFooter>
</template>

<script setup lang="ts">
import { UiButton, UiInput, Toggle } from '@dacr/ui'
import DialogHeader from '@/shared/dialogs/DialogHeader.vue'
import DialogContent from '@/shared/dialogs/DialogContent.vue'
import DialogFooter from '@/shared/dialogs/DialogFooter.vue'
import { useDialog } from '@/shared/dialogs/useDialog'
import { ref } from 'vue'
import { ToastType, useToastStore } from '@/shared/stores/toast'

const { close } = useDialog()
const toastStore = useToastStore()

const companyName = ref('')
const useCompanyName = ref(false)

const handleSubmit = async () => {
  toastStore.showToast({
    type: ToastType.Success,
    content: 'Company name updated',
  })

  close()
}
</script>
